export default __webpack_public_path__ + "static/media/Engineering Science.20800cde.pdf";